import { getTeam, changeTeam, TemplateCenter } from '@/config/axios/new_api'
import { Login } from '@/config/axios/new_api'
import tokenFunc from "@/config/static/token";
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
//getTeam, changeTeam
export default new Vuex.Store({
  state: {
    loginInfo: null,
    teamList: [],
    is_open: 1,
    logoForm: {
      logo: "",
      name: "",
    },
    currentTeam:{},
  },
  mutations: {
    loginInfo(state, data) {
      state.loginInfo = data;
    },
    teamList(state, data) {
      state.teamList = data;
    },
    is_open(state, data) {
      state.is_open = data;
    },
    logoForm(state, data) {
      state.logoForm = data;
    },
    changeCurrentTeam(state, data){
        state.currentTeam = data
    }
  },
  actions: {
    changeTeam(state) {
      return new Promise((resolve) => {
        let token = tokenFunc.getToken();
        if (token) {
          getTeam().then((res) => {
            if (res) {
              if (!res.status) {
                return resolve(2);
              }
              let data = res.data && (res.data).map(item => {
                if (process.env.VUE_APP_RealmName) {
                  if (item.domain.indexOf("//") !== -1) {
                    let splitArr = item.domain.split("//");
                    let endArr = splitArr[1].split(".");
                    let endStr = endArr[0] + "." + process.env.VUE_APP_RealmName;
                    item.domain = `https://${endStr}`;
                  }
                }
                return item;
              });
              let list = data;
              if (data && data.length) {
                state.commit("teamList", data);
                let host = window.location.host;
                let currentTeam = list.find((item) => {
                  let domain = item.domain.split("//")[1];
                  if (process.env.VUE_APP_RealmName) {
                    // 这地方加了一层判断
                    return domain.split('.')[0].toLowerCase() === host.split('.')[0]
                  } else {
                    if (domain) {
                      return domain.toLowerCase() === host;
                    }
                  }
                });
                if (currentTeam) {
                  changeTeam({
                    team_id: currentTeam.id,
                  }).then((res) => {
                    return resolve(res.status);
                  });
                } else {
                  return resolve(0); // 0 代表失败
                }
              } else {
                return resolve(0);
              }
            } else {
              return resolve(0);
            }
          });
        } else {
          resolve(0);
        }
      });
    },
    loginInfo({ commit }, loginObj = {}) {
      let token = tokenFunc.getToken();
      console.log(token, 'token')
      if (token) {
        return new Promise((resolve) => {
          Login.getUserInfo(loginObj).then((res) => {
            if (res && res.status === 1) {
              let data = res.data;
              commit("loginInfo", data);
              commit("logoForm", {
                logo: data.current_team_logo,
                name: data.current_team_name,
              });
              resolve(data);
            }
            resolve(0);
          });
        });
      } else {
        if (window.location.href.indexOf("login") === -1) {
          window.location.href = process.env.VUE_APP_BASELogout;
        }
      }
    },
  },
  modules: {},
  getters: {
    loginInfo: (state) => state.loginInfo,
    teamList: (state) => state.teamList,
    is_open: (state) => state.is_open,
    logoForm: (state) => state.logoForm,
    currentTeam: (state) => state.currentTeam,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
});
